module.exports = __webpack_public_path__ + "img/Hero@2x.985a7c6a.png";